import React from "react";
import { valuesStyles } from "../style/valuesStyle";
import valuesData from "../data/values.json"

const Values: React.FC = () => {
  return (
    <div style={valuesStyles.container}>
      <h2 style={valuesStyles.sectionTitle}>Our Process</h2>
      <div style={valuesStyles.valuesGrid}>
        {valuesData.map((value, index) => (
          <div key={index} style={valuesStyles.valueItem}>
            <div style={valuesStyles.number}>{`0${index + 1}`}</div>
            <h3 style={valuesStyles.valueTitle}>{value.title}</h3>
            <p style={valuesStyles.valueText}>{value.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Values;
